import { useRecoilValue } from "recoil";
import PageCategory from "./pageMenu/PageCategory";
import PageGameList from "./pageMenu/PageGameList";
import PageSearch from "./pageMenu/PageSearch";
import { searchToggleState } from "recoil/commonUiAtom";
import { useMediaQuery } from "react-responsive";
import { isProfilePageState } from "recoil/contentsAtom";

function PageLeft() {
  const searchToggle = useRecoilValue(searchToggleState);
  const width768 = useMediaQuery({
    query: "screen and (max-width: 768px)"
  });
  const isProfilePage = useRecoilValue(isProfilePageState);

  const toggleType = width768 ? (searchToggle ? true : false) : true;

  return (
    <div className="page-left">
      {!isProfilePage && (toggleType ? <PageSearch /> : null)}
      <PageCategory />
      <PageGameList />
    </div>
  );
}

export default PageLeft;
